import { SectionableRaw, SectionRaw } from 'pages/reporting/reports/rug/types'
import { GeckoMeasurement, Section, Sectionable } from 'types'

export function sectionToRaw(section: Section): SectionRaw {
  return {
    name: section.name,
    min: section.min.toJSON(),
    max: section.max.toJSON(),
  }
}

export function sectionFromRaw(sectionRaw: SectionRaw): Section {
  return {
    name: sectionRaw.name,
    min: GeckoMeasurement.CreateFromJSON(sectionRaw.min),
    max: GeckoMeasurement.CreateFromJSON(sectionRaw.max),
  }
}

export function sectionableToRaw(sectionable: Sectionable): SectionableRaw {
  return {
    ...sectionable,
    sections: sectionable.sections.map((section) => sectionToRaw(section)),
  }
}

export function sectionableFromRaw(
  sectionableRaw: SectionableRaw
): Sectionable {
  return {
    ...sectionableRaw,
    sections: sectionableRaw.sections.map((section) => sectionFromRaw(section)),
  }
}
